import Glide from '@glidejs/glide';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

export default {
  init() {
    // Misc scripts --------------------------------------------------
    window.fbAsyncInit = function() {
      window.FB.init({
        appId      : '530162134416650',
        xfbml      : true,
        version    : 'v2.5',
      });
    };
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    $('.facebook-share-button').click(function(e) {
      e.preventDefault();
      window.FB.ui({
        method: 'share',
        href: window.location.href,
      }, function() {});
    })
    // End misc scripts --------------------------------------------------
  },
  finalize() {
    if($('.editor-pick-carousel').length) {
      $(window).load(function() {
        new Glide('.editor-pick-carousel', {
          type: 'carousel',
          startAt: 0,
          perView: 1,
          animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
          breakpoints: {
            1023: {
              perView: 3,
            },
            767: {
              perView: 2,
            },
            575: {
              perView: 1,
            },
          },
        }).mount();
      });
    }

    var thumbs = new Glide('.product-thumbs-carousel', {
      type: 'carousel',
      startAt: 0,
      perView: 1,
      animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
    });
    if($(window).width() < 769 && $('.small-thumbs').length > 0) {
      thumbs.mount();
    }

    $('.product-video').click(function() {
      // if($(this).data('video').length) {
        // const modal = $(this).data('video');
        // $('[data-modal="' + modal + '"]')

        // console.log('data-video', $(this).data('video'));
      // } else {
        $('.modal.video-modal:not([data-modal="banner-video"])').addClass('open');
      // }
    });

    $('figure.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image a').click(function(e) {
      e.preventDefault();
        var prodImg = $('figure.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image a').find('img');
      $('.modal.prod-images-modal img').attr('src', prodImg.attr('src'));
      $('.modal.prod-images-modal img').attr('alt', prodImg.attr('alt'));
      $('.modal.prod-images-modal img').attr('title', prodImg.attr('title'));

      if(!$(this).hasClass('video-open')){
          $('.modal.prod-images-modal').addClass('open');
      }else{
          $('.modal.video-modal[data-modal="banner-video"]').addClass('open');
      }
    });

    $('.modal .x, .modal').click(function() {
      $('.modal').removeClass('open');
      var thesrc = $('.modal iframe').attr('src');
      $('.modal iframe').attr('src', '').attr('src', thesrc);
    });

    $('.modal .modal-inner *').click(function(e) {
      e.stopPropagation();
    });

    $(document).on('change', 'input[name="subscription-selected"]', function() {
      if($(this).prop('checked') === true) {
        $('.subscription-options').slideDown(100);
        $('input[value="1_month"]').prop('checked', true);
        $('li.subscription').addClass('selected');
        $('li.one-time').removeClass('selected');
      } else {
        $('.subscription-options').slideUp(100);
        $('li.subscription').removeClass('selected');
        $('li.one-time').addClass('selected');
      }
    });

    $(document).on('change', '.no-subscription', function() {
      if($(this).prop('checked') === true) {
        $('input[name="subscription-selected"]').prop('checked', false);
        $('.subscription-options').slideUp(100);
        $('li.subscription').removeClass('selected');
        $('li.one-time').addClass('selected');
      } else {
        $('.subscription-options').slideDown(100);
        $('li.subscription').addClass('selected');
        $('li.one-time').removeClass('selected');
      }
    });

    $(document).on('click', 'li.one-time', function() {
      $(this).addClass('selected');
      $('li.subscription').removeClass('selected');
      $('.no-subscription').prop('checked', true).change();
      $('input[name="subscription-selected"]').prop('checked', false);
      $('.subscription-options').slideUp(100);
    });

    $(document).on('click', 'li.subscription', function() {
      if(!$(this).hasClass('selected')) {
        $(this).addClass('selected');
        $('li.one-time').removeClass('selected');
        $('input[value="1_month"], input[name="subscription-selected"]').prop('checked', true).change();
        $('.subscription-options').slideDown(100);
      }
    });

    $(document).on('click', 'li.subscription ul', function(e) {
      e.stopPropagation();
    });

    $(document).on('click', '.small-thumbs img', function(e) {
      e.preventDefault();

      if($(window).width() >= 768) {
        $('.glide__slide').removeClass('glide__slide--opacity');
        $(this).parents('.glide__slide').addClass('glide__slide--opacity');
        var fullthumb = $('figure.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image img, figure.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image source');
        var el = $(this);

        fullthumb.addClass('beforechange');
        if($(this).closest('li').hasClass('product-video-slide')) {
          fullthumb.closest('a').addClass('video-open');
        } else {
          fullthumb.closest('a').removeClass('video-open');
        }
        setTimeout(function() {
          var largeImg = el.attr('data-large_image') ? el.attr('data-large_image') :  el.attr('src');
          fullthumb.attr('src', largeImg)
          fullthumb.attr('alt', el.attr('alt'))
          fullthumb.attr('title', el.attr('title'))
          fullthumb.removeAttr('srcset');
          fullthumb.one('load', function() {
            fullthumb.removeClass('beforechange');
          });
          if (fullthumb.complete) {
            fullthumb.load();
          }
        }, 400);
      }
    });

    $(window).load(function() {
      var fullthumb = $('figure.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image img');
      fullthumb.attr('src', fullthumb.attr('data-large_image'));
      fullthumb.removeAttr('srcset');
    });

    $('li[role="tab"]').click(function() {
      if($(window).width() < 768) {
        $(this).toggleClass('open').next('.tab-content-mobile').slideToggle(200);
      }
    });

    $('ul.tabs li[role="tab"]:first-child').addClass('open');

    // Lazy loading larger product images on carousel scroll on mobile on product pages on beautybyearth website on the internet
    if(thumbs) {
      thumbs.on('move.after', function() {
        $('.small-thumbs .glide__slide.glide__slide--active img:not(.fullres), .small-thumbs .glide__slide.glide__slide--active source:not(.fullres)').attr('src', $('.small-thumbs .glide__slide.glide__slide--active img').attr('data-large_image')).attr('srcset', '').attr('sizes', '').addClass('fullres');
      });

      // $(window).load(function() {
      //   thumbs.mount();
      // });
      let currentww = $(window).width();
      $(window).resize(function () {
        let ww = $(window).width();
        if (currentww < 769 && ww > 768) {
          document.location.reload();
        } else if (currentww > 768 && ww < 769) {
          document.location.reload();
        }
      });
    }

    $(window).load(function() {
      $('.modal').removeAttr('style');
    });

    $(window).load(function () {
      // Check if apply pay is available on current browser.

      if (window.ApplePaySession) {
        $('input[name="subscription-selected"]').on('change', function () {
          if($(this).prop('checked') === true) {
            $('body').find('#wc-stripe-payment-request-wrapper').hide();
          }
        });

        $('input.no-subscription').on('change', function() {
          if ($(this).prop('checked') === true) {
            $('body').find('#wc-stripe-payment-request-wrapper').show();
          }
        });
      }
    });

    // Hack to fix issue with links not opening on mobile in product tabs/accordions
    $(document).on('click', '.tab-content-mobile li a', function(e) {
      e.preventDefault();
      window.open($(this).attr('href'), $(this).attr('target'));
    });

    $(document).on('click touchend', '.fake-tabs li:not(.open) a', function(e) {
      $('.fake-tabs li.open').removeClass('open');
      if($(this).parent().attr('data-tab') == undefined) {
        $('.fake-tabs li a[href="#' + $('div.woocommerce-Tabs-panel:visible').attr('id') + '"]').parent().addClass('open');
      } else {
        e.preventDefault();
        $(this).parent().addClass('open');
      }
      $('.woocommerce-tabs > ul.tabs li.' + $(this).parent().attr('data-tab') + ' a').click();
    });

    $(document).on('click touchend', '.fake-tabs li.open', function(e) {
      e.preventDefault();
    });

    $(document).ready(function() {
      $('div.woocommerce-Tabs-panel').attr('style', 'display:none;');
    });

    $(document).on('click', 'li.product-video-slide', function() {
      if($(window).width() < 768) {
        $('.modal.video-modal[data-modal="banner-video"]').addClass('open');
      }
    });

    function populate_subscription_price() {
      if($('.woocommerce-variation-price > .price').length) {
        $('.wcsatt-options-product li.one-time-option .price').text($('.woocommerce-variation-price > .price .amount').text());
      }

      if($('.wcsatt-options-product .subscription-option').length) {
        var price = parseFloat(($('.woocommerce-variation-price > .price .amount').text()).replace('$', ''));
        var minusTenPercent = '$' + (price * 0.90).toFixed(2);
        $('.wcsatt-options-product li.subscription .price').text(minusTenPercent);
      }

      if($('.woocommerce-variation-price .wcsatt-options-wrapper').length) {
        $('.woocommerce-variation-price > .price').hide();
      }
    }

    $(document).on('woocommerce_variation_select_change', function() {
      // Fires whenever variation selects are changed
      if ($('.product-type-variable').length > 0) {
        populate_subscription_price();
      }
    });

    $(document).on( 'show_variation', function() {
      // Fired when the user selects all the required dropdowns / attributes and a final variation is selected / shown
      if ($('.product-type-variable').length > 0) {
        populate_subscription_price();
      }
    });

    $(document).on('click', '.whats-inside__info__see-all__link', function(e) {
      e.preventDefault();
      $(this).parent().toggleClass('whats-inside__info__see-all--active');
    });

    if ($('.see-results .swiper-container').length >0) {
      let results = new Swiper('.see-results .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.see-results .swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
      });
      $('.see-results .swiper-container').on('mouseenter', function(){
        results.autoplay.stop();
      });
      $('.see-results .swiper-container').on('mouseleave', function(){
        results.autoplay.start();
      });
    }

    if ($('.differents .swiper-container').length > 0) {
      new Swiper('.differents .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: '.differents .swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
      });
    }

    if ($('.review_slider .swiper-container').length > 0) {
      let review_slider = new Swiper('.review_slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.review_slider .swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        },
      });
      $('.review_slider .swiper-container').on('mouseenter', function(){
        review_slider.autoplay.stop();
      });
      $('.review_slider .swiper-container').on('mouseleave', function(){
        review_slider.autoplay.start();
      });
    }

    $(document).on('click', '.asked-questions__key', function() {
      $(this).parent().toggleClass('asked-questions__item--active');
    });

    $(document).on('click', '.more_details__button, .what-inside__button, .review_slider__button, .review-use__how-use__button, .prefect-for__button, .deets__button', function() {
      $('.single_add_to_cart_button').trigger('click');
      $(this).css('opacity', '0.6');
    });

    $(document).on('click', '.product__get-it-free, .product__get-it-free__popup__close', function() {
      $('.product__get-it-free__popup').toggleClass('product__get-it-free__popup--active');
    });
    $(document).on('click', '.product__modal-video__close', function() {
      $('.product__modal-video__iframe iframe').remove();
      $('.product__modal-video').removeClass('product__modal-video--active');
    });
    $(document).on('click', '.product__modal-image__close', function() {
      $('.product__modal-image').removeClass('product__modal-image--active');
    });
    $(document).on('click', '.modal-product__video', function() {
      let iframe = $(this).attr('data-video');
      if (iframe.length > 0) {
        $('.product__modal-video__iframe iframe').remove();
        $('.product__modal-video__iframe').append(iframe);
        $('.product__modal-video').addClass('product__modal-video--active');
      } else {
        let image = $(this).css( 'background-image' );
        image = image.replace('url(','').replace(')','').replace('"','').replace('"','');
        $('.product__modal-image__img img').attr('src', image);
        $('.product__modal-image').addClass('product__modal-image--active');
      }
    });
    let rotateCircle = true;
    $(document).on('click', '.whats-inside__ingredients__square', function() {
      let item = $(this).attr('data-item');
      $('.whats-inside__ingredients__square').removeClass('whats-inside__ingredients__square--active');
      $(this).addClass('whats-inside__ingredients__square--active');
      $('.whats-inside__info__list').removeClass('whats-inside__info__list--active');
      $('.whats-inside__info__list[data-item="'+item+'"]').addClass('whats-inside__info__list--active');
      rotateCircle = false;
    });
    if ($('.whats-inside__info').length > 0)
    {
      rotateItems();
    }
    function rotateItems() {
      if (rotateCircle) {
        let item = $('.whats-inside__ingredients__square--active').attr('data-item');
        if ((parseInt(item) + 1) > 7) {
          item = 1;
        } else {
          item = parseInt(item) + 1;
        }
        $('.whats-inside__ingredients__square').removeClass('whats-inside__ingredients__square--active');
        $('.whats-inside__info__list').removeClass('whats-inside__info__list--active');
        $('.whats-inside__info__list[data-item="'+item+'"]').addClass('whats-inside__info__list--active');
        $('.whats-inside__ingredients__square[data-item="'+item+'"]').addClass('whats-inside__ingredients__square--active');
        setTimeout(function(){ rotateItems(); }, 2000);
      }
    }
    $(document).on('click', '.review-use__how-use__item-text--underline', function() {
      if ($(this).parent().hasClass('review-use__how-use__item-text--active')) {
        $(this).html('+');
      } else {
        $(this).html('-');
      }
      $(this).parent().toggleClass('review-use__how-use__item-text--active');
    });
    $(document).on('keydown', function(event) {
      if (event.key =='Escape') {
        $('.product__modal-video__iframe iframe').remove();
        $('.product__modal-video').removeClass('product__modal-video--active');
        $('.product__modal-image').removeClass('product__modal-image--active');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js